import { render } from "./HeroiconsSolidMoon.vue?vue&type=template&id=7aeb9e8a"
const script = {}

import exportComponent from "/home/nginx/domains/panel.vip-mod.net/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidMoon.vue"]])

export default __exports__